var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_51_x2C__Business_x2C__Marketing_x2C__Seo_x2C__Target_x2C__Work"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m432.748 79.196c-47.219-47.219-109.999-73.224-176.776-73.224s-129.559 26.004-176.777 73.224c-47.219 47.219-73.223 109.999-73.223 176.776s26.004 129.558 73.223 176.777c97.701 97.699 255.841 97.711 353.554 0 97.699-97.7 97.712-255.84-.001-353.553zm-176.776 406.776c-126.822 0-230-103.178-230-230s103.178-230 230-230 230 103.178 230 230-103.178 230-230 230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.972 75.972c-99.253 0-180 80.747-180 180 0 99.251 80.747 180 180 180 99.252 0 180-80.748 180-180s-80.748-180-180-180zm0 340c-88.225 0-160-71.775-160-160 0-88.224 71.775-160 160-160s160 71.776 160 160-71.776 160-160 160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.972 145.972c-60.654 0-110 49.346-110 110s49.346 110 110 110 110-49.346 110-110-49.346-110-110-110zm0 200c-49.626 0-90-40.374-90-90s40.374-90 90-90 90 40.374 90 90-40.374 90-90 90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.972 215.972c-22.057 0-40 17.944-40 40 0 22.055 17.943 40 40 40 22.056 0 40-17.944 40-40s-17.945-40-40-40zm0 60c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularTarget);
export default __webpack_public_path__ + "static/media/circular_target.3a2df07132a694ed5d1a513ef9d4338d.svg";
export { ForwardRef as ReactComponent };